import { render, staticRenderFns } from "./Button_Gradient.vue?vue&type=template&id=4cc7e9b3&scoped=true&"
import script from "./Button_Gradient.vue?vue&type=script&lang=js&"
export * from "./Button_Gradient.vue?vue&type=script&lang=js&"
import style0 from "./Button_Gradient.vue?vue&type=style&index=0&id=4cc7e9b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7e9b3",
  null
  
)

export default component.exports